import auth from './auth'
import app from './app'
import menu from './menu'
import ui from './ui'
import footer from './footer'

export default {
  auth,
  app,
  menu,
  ui,
  footer
}
